module.exports = __webpack_public_path__ + "static/img/5.8bb25f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/5.jpg
// module id = pBTU
// module chunks = 21